import React from 'react'
import { RecoverPasswordFormCP } from 'modules/auth/components/recover-password-form/RecoverPasswordFormCP'
import { RoutingHelper } from 'common/helpers/RoutingHelper'
import { AuthRoutes } from 'modules/auth/AuthRoutes'
import { AuthLayoutCP } from 'modules/auth/components/auth-layout/AuthLayoutCP'

/**
 * TELA: Recuperar senha.
 *
 * @author hjcostabr
 */
export function RecoverPasswordScreen(): JSX.Element {

    return (
        <AuthLayoutCP
            content={
                <RecoverPasswordFormCP goToLogin={() => RoutingHelper.historyPush(AuthRoutes.USER_LOGIN)}/>
            }
        />
    )
}
